import { ProjectFragment } from '../../fragments.generated';
import {
  ProjectAccessAction,
  ProjectAccessSubject,
} from '../../../../server/abilities/ProjectAccessEnums';

export interface Project
  /**
   * Needed for presentation of card
   *  'id' | 'name' | 'clientName' | 'clipsCount' | 'studioVersion'
   * But entire fragment needed for project actions menu
   */
  extends ProjectFragment {
  projectOwner: string;
}

export { ProjectAccessAction };
export { ProjectAccessSubject };
